import { RocheUIStockPrice } from '@repo/roche-ui';
import React, { useEffect, useState } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { useTranslation } from '../../hooks/use-translation';
import { ExternalDataService } from '../../services/external-data';
import { StockInformation, StockInformationCategory } from '../../services/external-data/types';
import { StringService } from '../../services/string';

const getCurrencyOrUndefined = (input: unknown) =>
  typeof input === 'string' && input !== 'N/A' && input !== '#N/A' ? input : undefined;
const getNumberOrUndefined = (input: unknown) => (typeof input === 'string' ? Number(input) : undefined);

type RocheStockPriceProps = BlokToComponentProps<{
  href?: {
    story?: {
      full_slug?: string;
    };
  };
}>;

export const RocheStockPrice = ({ blok, slot }: RocheStockPriceProps) => {
  const [stockInformation, setStockInformation] = useState<StockInformation | null>(null);

  useEffect(() => {
    ExternalDataService.getStockInformation({ category: StockInformationCategory.SWX_ROG }).then(
      (result: StockInformation) => setStockInformation(result),
    );
  }, []);

  const heading = useTranslation('share price');
  const timeInterval = useTranslation('today');
  const sharePriceUnavailableLabel = useTranslation('share price currently unavailable');
  const href = `/${blok?.href?.story?.full_slug ?? ''}`;

  if (!stockInformation) {
    return null;
  }

  const price = getNumberOrUndefined(stockInformation.Price);
  const currency = getCurrencyOrUndefined(stockInformation.Currency);
  const change = getNumberOrUndefined(stockInformation.Change);
  const changePercentage = getNumberOrUndefined(stockInformation['Change Percentage']);

  return (
    <div slot={slot}>
      <RocheUIStockPrice
        currency={currency}
        href={href}
        price={price}
        change={change}
        relativeChange={changePercentage}
        heading={StringService.capitalize(heading)}
        timeIntervalLabel={StringService.capitalize(timeInterval)}
        unavailableLabel={sharePriceUnavailableLabel}
      ></RocheUIStockPrice>
    </div>
  );
};
